export default __webpack_public_path__ + "static/media/1920.dea40cc2.png";